enum geoLocationAutocomplete {
  SUCCESS = 'SET_GEO_LOCATION_AUTOCOMPLETE_SUCCESS',
  FAILURE = 'SET_GEO_LOCATION_AUTOCOMPLETE_FAILURE',
  RESET = 'GEO_LOCATION_AUTOCOMPLETE_RESET'
}

export default geoLocationAutocomplete;
